var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.id,staticClass:"modal modal-normal fade",attrs:{"id":_vm.id,"tabindex":"-1","aria-labelledby":_vm.id + '-label',"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }